import SelectClass from '../class/SelectClass';

class UtilFactory {
  constructor(scope) {
    this.objects = [];
    this.allowedObjectsNames = {
      select: new SelectClass(scope),
    };
  }

  getUtilObject(objectName) {
    if (!this.allowedObjectsNames.hasOwnProperty(objectName)) {
      return null;
    } else {
      if (this.objects.hasOwnProperty(objectName)) {
        return this.objects[objectName];
      } else {
        let utilObject = this.allowedObjectsNames[objectName];
        this.objects[objectName] = utilObject;

        return utilObject;
      }
    }
  }
}

export default UtilFactory;
